export interface ContentfulRenderOptions {
  localization?: boolean
  linkType?: string
}

export const DEFAULT_RENDER_OPTIONS: ContentfulRenderOptions = {}
